export const SITE_URL = 'https://gastro-beratung.de';
export const SITE_NAME = 'gastro-beratung.de';
export const LOGO_URL = `${SITE_URL}/logo.png`;
export const DEFAULT_IMAGE = `${SITE_URL}/og-default.jpg`;
export const DEFAULT_DESCRIPTION =
  'Unabhängige Digitalisierungsberatung für die Gastronomie: Kassensysteme, Reservierung, Bestellsysteme, Delivery, Personalplanung & mehr. Kostenfreie Erstberatung, persönliche Betreuung, herstellerneutral.';

export const absUrl = (path) => `${SITE_URL}${path === '/' ? '' : path}` || SITE_URL;

export const WEBSITE_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  url: SITE_URL,
  name: 'Gastro-Beratung.de',
  inLanguage: 'de-DE',
  publisher: { '@id': `${SITE_URL}/#organization` },
};

export const breadcrumbJsonLd = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: item.name,
    item: absUrl(item.path),
  })),
});

const withBrand = (title) => `${title} | ${SITE_NAME}`;

export const PAGE_SEO = {
  home: {
    path: '/',
    title: 'Gastro-Beratung.de – Unabhängige Digitalisierungsberatung für die Gastronomie',
    description: DEFAULT_DESCRIPTION,
    jsonLd: [WEBSITE_JSONLD],
  },
  loesungen: {
    path: '/loesungen',
    title: withBrand('Digitale Lösungen für die Gastronomie – Kasse, Reservierung, Order & mehr'),
    description:
      'Wir strukturieren, integrieren und betreuen deine digitalen Systeme: Kassensystem & Kartenzahlung, Reservierung, Personalplanung, Smart Order, Delivery, Loyalty, Social Media, Website, Reporting und Warenwirtschaft – herstellerneutral.',
    jsonLd: [
      breadcrumbJsonLd([{ name: 'Startseite', path: '/' }, { name: 'Lösungen', path: '/loesungen' }]),
      {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Digitalisierungsberatung für die Gastronomie',
        provider: { '@id': `${SITE_URL}/#organization` },
        serviceType: 'Unabhängige Systemberatung, Integration, Schulung und Support für Gastronomiebetriebe',
        areaServed: { '@type': 'Country', name: 'Deutschland' },
        url: `${SITE_URL}/loesungen`,
      },
    ],
  },
  ueberUns: {
    path: '/ueber-uns',
    title: withBrand('Über uns – Das Team hinter Gastro-Beratung.de'),
    description:
      'Lerne das Team von Gastro-Beratung.de kennen: Mission, Werte und Geschichte einer unabhängigen Beratung, die Gastronomen bei der Digitalisierung persönlich begleitet.',
    jsonLd: [breadcrumbJsonLd([{ name: 'Startseite', path: '/' }, { name: 'Über uns', path: '/ueber-uns' }])],
  },
  erstberatung: {
    path: '/erstberatung',
    title: withBrand('Kostenlose Erstberatung für Gastronomen – digitale Systeme sinnvoll verbinden'),
    description:
      'In wenigen Minuten zur kostenlosen Erstberatung: Wir analysieren deine digitale Landschaft – Kasse, Reservierung, Bestellung, Personal – und zeigen herstellerneutral, was zu deinem Betrieb passt.',
    jsonLd: [breadcrumbJsonLd([{ name: 'Startseite', path: '/' }, { name: 'Erstberatung', path: '/erstberatung' }])],
  },
  insights: {
    path: '/insights',
    title: withBrand('Insights – Wissen zur Digitalisierung in der Gastronomie'),
    description:
      'Ausführliche Leitfäden und praxisnahe Vertiefungen zu Kassensystemen, Reservierung, Personalplanung, Smart Order, Delivery, Loyalty, Social Media, Website, Reporting und Warenwirtschaft – herstellerneutral erklärt.',
  },
  impressum: {
    path: '/impressum',
    title: withBrand('Impressum'),
    description: 'Impressum der GND Gastro Next Digital UG (haftungsbeschränkt), Betreiberin von gastro-beratung.de, Hamburg.',
  },
  datenschutz: {
    path: '/datenschutz',
    title: withBrand('Datenschutzerklärung'),
    description: 'Datenschutzerklärung von gastro-beratung.de: Informationen zur Verarbeitung personenbezogener Daten auf unserer Website und Plattform.',
  },
  bildquellen: {
    path: '/bildquellen',
    title: withBrand('Bildquellen'),
    description: 'Nachweis der auf gastro-beratung.de verwendeten Bilder und Fotografen (Unsplash, Pexels).',
  },
};

export const NOINDEX_TITLES = {
  '/login': 'Kundenlogin',
  '/register': 'Registrierung',
  '/passwort-vergessen': 'Passwort vergessen',
  '/passwort-reset': 'Passwort zurücksetzen',
  '/einladung': 'Einladung annehmen',
  '/registrierung-geprueft': 'Registrierung wird geprüft',
  '/freischaltung-ausstehend': 'Freischaltung ausstehend',
  '/verify-email': 'E-Mail bestätigen',
  '/portal': 'Kundenportal',
  '/admin': 'Admin',
  '/qr': 'Weiterleitung',
  '/dashboard': 'Kundenportal',
  '/social-media-showcase': 'Social Media Showcase',
};
